import { render, staticRenderFns } from "./NavBarMobileBottom.vue?vue&type=template&id=0f4b7481&scoped=true"
import script from "./NavBarMobileBottom.vue?vue&type=script&lang=js"
export * from "./NavBarMobileBottom.vue?vue&type=script&lang=js"
import style0 from "./NavBarMobileBottom.vue?vue&type=style&index=0&id=0f4b7481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b7481",
  null
  
)

export default component.exports